module.exports = __webpack_public_path__ + "static/media/fnbBank.3e5d03b6.png";